/**
 * 애플리케이션 라우트 경로 상수
 * 기획: PartnerStation MVP (01 로그인 · 05 사용자 · 06 거래처 정보 · 07 처방 등록 현황)
 * enum 대신 as const — TanStack Router가 경로 리터럴로 타입을 좁힐 수 있게 한다.
 */
export const ROUTE_PATHS = {
  LOGIN: '/',
  /** 로그인 성공 후 첫 화면 */
  USERS: '/users',
  CLIENTS: '/clients',
  PRESCRIPTIONS: '/prescriptions',
} as const;
